module.exports = __webpack_public_path__ + "media/common/interview-feature1-57164e0f.svg";